import { createContext, useContext, useRef } from "react";
import h from "@macrostrat/hyper";
var MapContext = /*#__PURE__*/createContext(null);
export function useMapRef() {
  return useContext(MapContext);
}
export function useMapElement() {
  return useMapRef().current;
}
export function useMap() {
  return useMapRef().current;
}
export function MapboxMapProvider(_ref) {
  var children = _ref.children;
  var mapRef = useRef();
  return h(MapContext.Provider, {
    value: mapRef
  }, children);
}